export default {
  en: "English",
  ar: "Arabic",
  es: "Spanish",
  pt: "Portugal",
  de: "German",
  ko: "Korean",
  ja: "Japanese",
  fr: "French",
  zh: "China simplified",
  // zh: "China traditional",
  ru: "Russian",
}